import { createRoot } from 'react-dom/client'
import { AppProvider } from './context/AppContext/AppContext'
import { MainProduct } from './types'
import { App } from './components/App'
import { format } from 'url'

declare global {
  interface Window {
    reloadBuilder: (mainProduct: MainProduct) => void
  }
}

const container = document.getElementById('feature-product-2d-builder')

if (!container) {
  throw new Error("Container for Product 2D Builder not found")
}

let root = createRoot(container)

const mainProductJsonString = container.dataset["mainProductJsonString"] as string
const originalMainProduct = JSON.parse(mainProductJsonString) as MainProduct
const linkedMainProductsJsonString = container.dataset["linkedMainProductsJsonString"] as string
const linkedMainProducts = JSON.parse(linkedMainProductsJsonString) as MainProduct[]
const cart = JSON.parse(container.dataset["cartJsonString"] as string)

const formatMainProductVariantOptions = (product: MainProduct) => {
  const formattedProduct = { ...product }
  const formatMetal = (metal: string) => {
    if (metal.toLowerCase() === 'yellow gold') return 'YG'
    if (metal.toLowerCase() === 'white gold') return 'WG'
    return metal
  }
  const formatLength = (length: string) => length.replaceAll('"', '').replaceAll('cm', '')

  product.optionsWithValues.forEach((optionWithValues, index) => {
    const { name, values } = optionWithValues

    if (name.toLowerCase() === 'metal') {
      formattedProduct.optionsWithValues[index] = {
        ...formattedProduct.optionsWithValues[index],
        values: values.map(value => formatMetal(value))
      }

      formattedProduct.variants.forEach(variant => {
        const metalValue = variant.options[index]
        variant.options[index] = formatMetal(metalValue)
      })
    }

    if (name.toLowerCase() === 'length') {
      formattedProduct.optionsWithValues[index] = {
        ...formattedProduct.optionsWithValues[index],
        values: values.map(value => formatLength(value))
      }

      formattedProduct.variants.forEach(variant => {
        const lengthValue = variant.options[index]
        variant.options[index] = formatLength(lengthValue)
      })
    }

    return optionWithValues
  })

  return formattedProduct
}

const formattedOriginalMainProduct = formatMainProductVariantOptions(originalMainProduct)
const formattedLinkedMainProducts = linkedMainProducts.map(product => formatMainProductVariantOptions(product))

window.reloadBuilder = (mainProduct: MainProduct) => {
  root!.unmount();
  root = createRoot(container);
  root.render(<RootApp mainProduct={formatMainProductVariantOptions(mainProduct)} remounted />);
}

interface Props {
  mainProduct: MainProduct
  remounted?: boolean
}

const RootApp = ({ mainProduct, remounted }: Props) => {
  const allProducts = [formattedOriginalMainProduct, ...formattedLinkedMainProducts];
  const updatedLinkedMainProducts = allProducts.filter(product => product.id !== mainProduct.id);

  return (  
     <AppProvider  
      mainProduct={mainProduct} 
      linkedMainProducts={updatedLinkedMainProducts}
      remounted={remounted}
      cart={cart}
    >
      <App /> 
    </AppProvider> 
  )
}

root.render(
  <RootApp mainProduct={originalMainProduct} />
)
